import { setTerm } from './helpers';

export const setCommercialPriceType = setTerm('price_type');
